import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TYPES } from '@antv/l7-core';
import { anchorTranslate, anchorType, applyAnchorClass, bindAll, DOM } from '@antv/l7-utils';
import { EventEmitter } from 'eventemitter3';

/** colse event */
var Popup = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Popup, _EventEmitter);

  var _super = _createSuper(Popup);

  function Popup(cfg) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _super.call(this);
    _this.popupOption = _objectSpread(_objectSpread({}, _this.getdefault()), cfg);
    bindAll(['update', 'onClickClose', 'remove'], _assertThisInitialized(_this));
    return _this;
  }

  _createClass(Popup, [{
    key: "addTo",
    value: function addTo(scene) {
      var _this2 = this;

      this.mapsService = scene.get(TYPES.IMapService);
      this.sceneSerive = scene.get(TYPES.ISceneService);
      this.mapsService.on('camerachange', this.update);
      this.mapsService.on('viewchange', this.update);
      this.scene = scene;
      this.update();

      if (this.popupOption.closeOnClick) {
        this.timeoutInstance = setTimeout(function () {
          _this2.mapsService.on('click', _this2.onClickClose);
        }, 30);
      }

      this.emit('open');
      return this;
    }
  }, {
    key: "close",
    value: function close() {
      this.remove();
    }
  }, {
    key: "open",
    value: function open() {
      this.addTo(this.scene);
    }
  }, {
    key: "setHTML",
    value: function setHTML(html) {
      var frag = window.document.createDocumentFragment();
      var temp = window.document.createElement('body');
      var child;
      temp.innerHTML = html;

      while (true) {
        child = temp.firstChild;

        if (!child) {
          break;
        }

        frag.appendChild(child);
      }

      return this.setDOMContent(frag);
    }
  }, {
    key: "setLnglat",
    value: function setLnglat(lngLat) {
      this.lngLat = lngLat;

      if (Array.isArray(lngLat)) {
        this.lngLat = {
          lng: lngLat[0],
          lat: lngLat[1]
        };
      }

      if (this.mapsService) {
        this.mapsService.on('camerachange', this.update);
        this.mapsService.on('viewchange', this.update);
      }

      this.update();
      return this;
    }
  }, {
    key: "getLnglat",
    value: function getLnglat() {
      return this.lngLat;
    }
  }, {
    key: "setText",
    value: function setText(text) {
      return this.setDOMContent(window.document.createTextNode(text));
    }
  }, {
    key: "setMaxWidth",
    value: function setMaxWidth(maxWidth) {
      this.popupOption.maxWidth = maxWidth;
      this.update();
      return this;
    }
  }, {
    key: "setDOMContent",
    value: function setDOMContent(htmlNode) {
      this.createContent();
      this.content.appendChild(htmlNode);
      this.update();
      return this;
    } // 移除popup

  }, {
    key: "remove",
    value: function remove() {
      if (this.content) {
        this.removeDom(this.content);
      }

      if (this.container) {
        this.removeDom(this.container); // @ts-ignore

        delete this.container;
      }

      if (this.mapsService) {
        // TODO: mapbox AMap 事件同步
        this.mapsService.off('camerachange', this.update);
        this.mapsService.off('viewchange', this.update);
        this.mapsService.off('click', this.onClickClose); // @ts-ignore

        delete this.mapsService;
      }

      clearTimeout(this.timeoutInstance);
      this.emit('close');
      return this;
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return !!this.mapsService;
    }
  }, {
    key: "createContent",
    value: function createContent() {
      if (this.content) {
        DOM.remove(this.content);
      }

      this.content = DOM.create('div', 'l7-popup-content', this.container);

      if (this.popupOption.closeButton) {
        this.closeButton = DOM.create('button', 'l7-popup-close-button', this.content);

        if (this.popupOption.closeButtonOffsets) {
          // 关闭按钮的偏移
          this.closeButton.style.right = this.popupOption.closeButtonOffsets[0] + 'px';
          this.closeButton.style.top = this.popupOption.closeButtonOffsets[1] + 'px';
        } // this.closeButton.type = 'button';


        this.closeButton.setAttribute('aria-label', 'Close popup');
        this.closeButton.innerHTML = '&#215;';
        this.closeButton.addEventListener('click', this.onClickClose);
      }
    }
  }, {
    key: "creatDom",
    value: function creatDom(tagName, className, container) {
      var el = window.document.createElement(tagName);

      if (className !== undefined) {
        el.className = className;
      }

      if (container) {
        container.appendChild(el);
      }

      return el;
    }
  }, {
    key: "removeDom",
    value: function removeDom(node) {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    }
  }, {
    key: "getdefault",
    value: function getdefault() {
      return {
        closeButton: true,
        closeOnClick: true,
        maxWidth: '240px',
        offsets: [0, 0],
        anchor: anchorType.BOTTOM,
        className: '',
        stopPropagation: true
      };
    }
  }, {
    key: "onClickClose",
    value: function onClickClose(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }

      this.remove();
    }
  }, {
    key: "update",
    value: function update() {
      var _this3 = this;

      var hasPosition = this.lngLat;
      var _this$popupOption = this.popupOption,
          className = _this$popupOption.className,
          maxWidth = _this$popupOption.maxWidth,
          anchor = _this$popupOption.anchor;

      if (!this.mapsService || !hasPosition || !this.content) {
        return;
      }

      var popupContainer = this.mapsService.getMarkerContainer();

      if (!this.container && popupContainer) {
        this.container = this.creatDom('div', 'l7-popup', popupContainer);
        this.tip = this.creatDom('div', 'l7-popup-tip', this.container);
        this.container.appendChild(this.content);

        if (className) {
          className.split(' ').forEach(function (name) {
            return _this3.container.classList.add(name);
          });
        } // 高德地图需要阻止事件冒泡 // 测试mapbox 地图不需要添加


        var stopPropagation = this.popupOption.stopPropagation;

        if (stopPropagation) {
          ['mousemove', 'mousedown', 'mouseup', 'click', 'dblclick'].forEach(function (type) {
            _this3.container.addEventListener(type, function (e) {
              e.stopPropagation();
            });
          });
        }

        this.container.style.whiteSpace = 'nowrap';
      }

      if (maxWidth && this.container.style.maxWidth !== maxWidth) {
        this.container.style.maxWidth = maxWidth;
      }

      this.updatePosition();
      DOM.setTransform(this.container, "".concat(anchorTranslate[anchor]));
      applyAnchorClass(this.container, anchor, 'popup');
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (!this.mapsService) {
        return;
      }

      var _this$lngLat = this.lngLat,
          lng = _this$lngLat.lng,
          lat = _this$lngLat.lat;
      var offsets = this.popupOption.offsets;
      var pos = this.mapsService.lngLatToContainer([lng, lat]);
      this.container.style.left = pos.x + offsets[0] + 'px';
      this.container.style.top = pos.y - offsets[1] + 'px';
    }
  }]);

  return Popup;
}(EventEmitter);

export { Popup as default };